import React from 'react';
import feather from 'feather-icons';
import { simpleSort } from "../../utils/simpleSort";
import LanguageAwareComponent from '../shared/LanguageAwareComponent';

const lang = window.ENV.REACT_APP_LANG;
const $ = window.$;



export class CaseStateModal extends LanguageAwareComponent {

    constructor(props) {
        super(props);
        this.state = {
            clickedId: props.clickedId,
            sortedWorkflows: [],
            sortedCaseActions: []
        };
    }

    componentDidMount() {
        // Call parent componentDidMount first
        super.componentDidMount();
        
        $('[data-toggle="tooltip"]').tooltip();
        
        // Initialize sorted data
        this.updateSortedData();
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if the prop has changed
        if (prevProps.clickedId !== this.props.clickedId) {
          this.setState({ clickedId: this.props.clickedId });
        }
        
        // Update sorted data when props change or language changes
        if (prevProps.params.workflowList !== this.props.params.workflowList ||
            prevProps.params.caseActions !== this.props.params.caseActions ||
            prevState.currentLanguage !== this.state.currentLanguage) {
            this.updateSortedData();
        }
        
        feather.replace();
    }

    updateSortedData = () => {
        this.setState({
            sortedWorkflows: this.getSortedWorkflows(),
            sortedCaseActions: this.getSortedCaseActions()
        });
    };

    toggleSelection = (idx, recordId) => {
        const newClickedId = this.state.clickedId === idx ? null : idx;
        this.setState({ clickedId: newClickedId }, () => {
            this.props.pinRecord(idx, newClickedId, recordId);
        });
    }

    openCustomizeCaseAccessWindow = () => {
        const { selectedButton, isShowWFSelect, t, workflowList, selectWorkflow, stateData } = this.props.params;

        // Check if a workflow needs to be selected
        const requiresWorkflowSelection = isShowWFSelect;
        
        // Use the selectWorkflow prop directly from React state - no DOM access needed
        const currentWorkflowSelection = selectWorkflow;
        
        // Check if no workflow list exists
        const workflowListMissing = !workflowList || workflowList.length === 0;
        
        // Check if no specific workflow is selected in the dropdown when required
        const noWorkflowSelected = requiresWorkflowSelection && 
                                (!currentWorkflowSelection || 
                                 currentWorkflowSelection === "" || 
                                 currentWorkflowSelection === "no-select");
        
        // Check if a workflow state name is required but not provided
        const noWorkflowState = (
            selectedButton === "customeState" && 
            (!stateData || !stateData.workflowStateName)
        );
        
        if (workflowListMissing) {
            // Display error notification if no workflow list is available
            $.notification(
                "error", 
                t("common.notification.error"), 
                t("portalSettings.caseStates.validationError.NO_WORKFLOWS_AVAILABLE") 
            );
            return;
        } else if (noWorkflowSelected) {
            // Display error notification if no specific workflow is selected
            $.notification(
                "error", 
                t("common.notification.error"), 
                t("portalSettings.caseStates.validationError.NO_WORKFLOW_SELECTED")
            );
            return;
        } else if (noWorkflowState) {
            // Display error notification if workflow state name is missing
            $.notification(
                "error", 
                t("common.notification.error"), 
                t("portalSettings.caseStates.validationError.NO_WORKFLOW_STATE_NAME") 
            );
            return;
        }
        
        // If a workflow is selected, show the modal
        $(function () {    
            $('#modal-customize-case-access').modal('show');
            $('#modal-customize-case-access').css('overflow-y', 'auto');
        });
    }

    // Get sorted workflows for the Custom list dropdown
    getSortedWorkflows = () => {
        const { workflowList } = this.props.params;
        if (!workflowList || workflowList.length === 0) return [];
        
        // Create a copy to avoid mutating original array and sort based on current language
        return [...workflowList].sort((a, b) => simpleSort(a, b, 'name'));
    };

    // Get sorted case actions for the Actions dropdown  
    getSortedCaseActions = () => {
        const { caseActions } = this.props.params;
        if (!caseActions || caseActions.length === 0) return [];
        
        // Create a copy to avoid mutating original array and sort based on current language
        return [...caseActions].sort((a, b) => simpleSort(a, b, 'title'));
    };

    render() {
        const { clickedId, sortedWorkflows, sortedCaseActions } = this.state;
        const { t, isEdit, errors, stateData, caseActions, handleRecords, selectedButton, selectWorkflow, workflowList, isShowWFSelect } = this.props.params;

        return (
            <div className="modal fade" id="modal-case-state" ref="modal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span></button>
                            <h4 className="modal-title">{isEdit && (t("common.edit")) || (t("common.add"))} {t("portalSettings.caseStates.actions.add.title")}</h4>
                        </div>
                        <div className="modal-body">
                            <ul className="nav nav-tabs pb-10">
                                <li className="nav-item active">
                                    <a className="nav-link" data-toggle="tab" href="#titleTab" role="tab">
                                        <span style={{ verticalAlign: 'middle', paddingRight: 'inherit' }}>
                                            <i data-feather="align-center" />
                                        </span>
                                        {t("portalSettings.caseStates.tabMenu.title")}
                                        </a>
                                        </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#settingsTab" role="tab">
                                    <span style={{ verticalAlign: 'middle', paddingRight: 'inherit' }}>
                                        <i data-feather="archive" />
                                    </span>   
                                        {t("portalSettings.caseStates.tabMenu.caseandAction")}
                                        </a></li>
                            </ul>
                            
                            <div className="tab-content">
                                <div className="tab-pane active" id="titleTab" role="tabpanel">
                                {
                                (<p className="info-text" dangerouslySetInnerHTML={{
                                    __html: t("portalSettings.caseStates.tabMenu.titleNotice"),
                                    }}> 
                                </p>)}
                            {isEdit && (<br />)}
                                <form>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={
                                            errors.name ? "form-group has-error" : "form-group"
                                        }>
                                            <label htmlFor="name">
                                                {t("portalSettings.caseStates.fields.name")}
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                id="name"
                                                defaultValue={stateData && isEdit && (stateData.name)}
                                                onChange={this.props.handleChange}
                                                placeholder={t(
                                                    "portalSettings.caseStates.placeholder.name"
                                                )}
                                            />
                                            {errors.name && (
                                                <span className="help-block">{errors.name}</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="description">
                                                {t("portalSettings.caseStates.fields.description")}
                                            </label>
                                            <input
                                                type="text"
                                                name="description"
                                                className="form-control"
                                                id="description"
                                                defaultValue={stateData && isEdit && (stateData.description)}
                                                onChange={this.props.handleChange}
                                                placeholder={t(
                                                    "portalSettings.caseStates.placeholder.description"
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className={
                                                errors.workflowStateIcon ? "form-group has-error" : "form-group"
                                            }>
                                                <label htmlFor="workflowStateIcon">
                                                    {t("portalSettings.caseStates.fields.icon")}
                                                </label>
                                                <input
                                                    type="text"
                                                    name="workflowStateIcon"
                                                    className="form-control"
                                                    id="workflowStateIcon"
                                                    defaultValue={stateData && isEdit && (stateData.workflowStateIcon)}
                                                    onChange={this.props.handleChange}
                                                    placeholder={t(
                                                        "portalSettings.caseStates.placeholder.icon"
                                                    )}
                                                />
                                                {errors.workflowStateIcon && (
                                                    <span className="help-block">{errors.workflowStateIcon}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={
                                                errors.buttonStyle ? "form-group has-error" : "form-group"
                                            }>
                                                <label htmlFor="buttonStyle">
                                                    {t("portalSettings.caseStates.fields.buttonStyle")}
                                                </label>
                                                <input
                                                    type="text"
                                                    name="buttonStyle"
                                                    className="form-control"
                                                    id="buttonStyle"
                                                    defaultValue={stateData && isEdit && (stateData.buttonStyle)}
                                                    onChange={this.props.handleChange}
                                                    placeholder={t(
                                                        "portalSettings.caseStates.placeholder.buttonStyle"
                                                    )}
                                                />
                                                {errors.buttonStyle && (
                                                    <span className="help-block">{errors.buttonStyle}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="description">
                                            {t("portalSettings.caseStates.fields.helpText")}
                                        </label>
                                        <textarea
                                            type="text"
                                            name="helpText"
                                            className="form-control"
                                            id="helpText"
                                            defaultValue={stateData && isEdit && (stateData.helpText)}
                                            key={stateData && isEdit && (stateData.helpText)}
                                            onChange={this.props.handleChange}
                                            placeholder={t(
                                                "portalSettings.caseStates.placeholder.helpText"
                                            )}
                                        />
                                    </div>
                                    </form>
                                </div>
                                <div className="tab-pane" id="settingsTab" role="tabpane2">
                                    <p className="info-text" dangerouslySetInnerHTML={{
                                        __html: t("portalSettings.caseStates.tabMenu.actionNotice"),
                                        }}> 
                                    </p>
                                    <br />
                                    <form>
                                    <div className="form-group" style={{ marginTop: 30 }} >
                                                <label id="casesVisible">
                                                    {t("portalSettings.caseStates.caseFilter.title")}
                                                </label>
                                                <table className="table table-bordered">
                                                    <tbody>
                                                        <tr key="allCase">
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className={selectedButton === "All_Applications" ? "btn btn-default btn-xs selected-btn" : "btn btn-default btn-xs"}
                                                                    style={{ marginRight: 10 }}
                                                                    title=""
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.handleCaseSelectButtonClick("All_Applications");
                                                                    }}
                                                                >
                                                                    <span><i data-feather="archive" /></span>
                                                                    {t("portalSettings.caseStates.caseFilter.allCase")}
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className={selectedButton === "My_Cases" ? "btn btn-default btn-xs selected-btn" : "btn btn-default btn-xs"}
                                                                    style={{ marginRight: 10 }}
                                                                    title=""
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.handleCaseSelectButtonClick("My_Cases");
                                                                    }}
                                                                >
                                                                    <span><i data-feather="user-check" />
                                                                    {t("portalSettings.caseStates.caseFilter.myCase")}
                                                                    </span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr key="custom">
                                                            <td>
                                                            <button
                                                                    type="button"
                                                                    className={!isShowWFSelect && selectedButton != "My_Cases" && selectedButton != "All_Applications" && selectedButton != "" ? "btn btn-default btn-xs selected-btn" : "btn btn-default btn-xs"}
                                                                    style={{ marginRight: 10 }}
                                                                    title=""
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.handleCaseSelectButtonClick("customeState");
                                                                    }}
                                                                >
                                                                    <span><i data-feather="check-circle" />
                                                                    {t("portalSettings.caseStates.caseFilter.state")}
                                                                    </span>
                                                                </button>
                                                            </td>
                                                            <td>
                                                            <button
                                                                    type="button"
                                                                    className={isShowWFSelect ? "btn btn-default btn-xs selected-btn" : "btn btn-default btn-xs"}
                                                                    style={{ marginRight: 10 }}
                                                                    title=""
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.handleCaseSelectButtonClick("case_filter");
                                                                    }}
                                                                >
                                                                    <span><i data-feather="crosshair" />
                                                                    {t("portalSettings.caseStates.caseFilter.custom")}
                                                                    </span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                    </div>
                                    <div className="row" id="workflowStateNameRow">
                                        <div className="col-md-6">
                                            <div className={
                                                errors.workflowStateName ? "form-group has-error" : "form-group"
                                            }>
                                                <label htmlFor="workflowStateName">
                                                    {t("portalSettings.caseStates.fields.workflowStateName")}
                                                </label>
                                                <input
                                                    type="text"
                                                    name="workflowStateName"
                                                    className="form-control"
                                                    id="workflowStateName"
                                                    defaultValue={stateData && isEdit && (stateData.workflowStateName)}
                                                    onChange={this.props.handleChange}
                                                    placeholder={t(
                                                        "portalSettings.caseStates.placeholder.workflowStateName"
                                                    )}
                                                />
                                                {errors.workflowStateName && (
                                                    <span className="help-block">{errors.workflowStateName}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {isShowWFSelect &&
                                    <div className="row" style={{ marginBottom: 15 }}>
                                            <div className="col-md-6">
                                                <div className={
                                                    errors.type ? "form-group has-error" : "form-group"
                                                }>
                                                    <label htmlFor="">
                                                    {t("portalSettings.caseStates.tabMenu.selectWorkflow")}
                                                    </label>
                                                  
                                                    {(!selectWorkflow  || (selectWorkflow && workflowList) )&& 
                                                    
                                                        <select
                                                            className="form-control"
                                                            id="selectWorkflowCaseTable"
                                                            name="selectWorkflowCaseTable"
                                                            onChange={this.props.handleWorkflowChange}
                                                            defaultValue = {selectWorkflow}
                                                        >
                                                            <option key={'no-select'} value="no-select">{t("portalSettings.userGroups.add.placeholder.workflow")}</option>
                                                            {
                                                                sortedWorkflows?.map(option => {
                                                                return (
                                                                    <option
                                                                        key={option.workflowId}
                                                                        value={option.workflowId}
                                                                    >
                                                                        {option.name}
                                                                    </option>
                                                                );
                                                            })}

                                                        </select>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={
                                                    errors.actionConditionButton ? "form-group has-error" : "form-group"
                                                }>
                                                 
                                                    <button
                                                            type="button"
                                                            id="caseAccess"
                                                            className="btn btn-primary"
                                                            onClick={this.openCustomizeCaseAccessWindow}
                                                            style={{marginTop:'23px'}}
                                                        >
                                                            <span>
                                                            {t("portalSettings.caseStates.caseAccess.add")}
                                                            <i data-feather="edit-3" style={{ marginLeft: '10px',verticalAlign: 'middle'}}/>
                                                            </span>      
                                                        </button>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        <div className="input-group" style={{ marginBottom: 15 }}>
                                            <div className="col-md-12" style={{ paddingLeft: 0 }}>
                                                <label>
                                                    {t("portalSettings.caseStates.fields.actions.select")}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    id="caseAction"
                                                    name="caseAction"
                                                    onChange={this.props.handleCaseActionChange}>
                                                    <option key="0" value="none">{t("portalSettings.caseStates.fields.actions.option.select")}</option>
                                                    {sortedCaseActions &&
                                                        sortedCaseActions.map(option => {
                                                            return (
                                                                <option key={option.id} value={option.id}>
                                                                    {this.props.generateTitle("portalSettings.caseStates.fields.actions.option", option.title, option.title)} : {option.selectedWorkflowName}
                                                                </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <span
                                                className="input-group-btn"
                                                style={{ paddingTop: 25 }}
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-md btn-default"
                                                    onClick={this.props.addRecord}
                                                >
                                                    <span className="glyphicon glyphicon-plus"></span>
                                                </button>
                                            </span>
                                        </div>

                                {handleRecords.length > 0 && (
                                    <div className="form-group" style={{ marginTop: 30 }} >
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>{t("portalSettings.caseStates.fields.actions.table.action")}</th>
                                                    <th>{t("portalSettings.caseStates.fields.actions.table.description")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {handleRecords.length > 0 &&
                                                    handleRecords.sort((a, b) => a.order > b.order ? 1 : -1).map((record, idx) => (
                                                        <tr key={record.name+record.order}>
                                                            <td>{this.props.generateTitle("portalSettings.caseStates.fields.actions.option", record.title, record.title)}</td>
                                                            <td>{record.name}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-default btn-xs"
                                                                    style={{ marginRight: 10 }}
                                                                    title="Move Up"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.moveUpCaseActionRecord("case_actions", record);
                                                                    }}
                                                                >
                                                                    <span><i className="fa fa-arrow-up"></i></span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-default btn-xs"
                                                                    style={{ marginRight: 10 }}
                                                                    title="Move Down"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.moveDownCaseActionRecord("case_actions", record);
                                                                    }}
                                                                >
                                                                    <span><i className="fa fa-arrow-down"></i></span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-default btn-xs"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        this.props.deleteRecord(idx);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-close"></i>
                                                                </button>
                                                                {record.type === "4" &&
                                                                    <button
                                                                        type="button"
                                                                        className={`btn btn-xs  ${(clickedId === idx) ? 'btn btn-default custom-btn-default' : 'btn-default'}`}
                                                                        onClick={e => {
                                                                            e.preventDefault();
                                                                            this.toggleSelection(idx, record.id);
                                                                        }}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title={t("portalSettings.caseStates.fields.actions.table.pinToolTip")}>
                                                                        <i className="fa fa-thumb-tack"></i>
                                                                    </button>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </form>
                                </div>
                            </div>
                            
                                </div>                                
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default pull-left"
                                data-dismiss="modal">{t("common.close")}
                            </button>
                            <button
                                type="button"
                                className="btn btn-default"
                                onClick={this.props.handleSave}
                            >{t("common.save")}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CaseStateModal;
